import { SVGProps, Ref, forwardRef } from 'react';

export const FlaskFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M8 13.9c1.448 0 2.372.598 3.5 1.349 1.126.749 2.456 1.651 4.5 1.651 1.675 0 3.493-.607 4.978-1.26 1.75 2.838 2.457 4.608 1.751 6.086a4 4 0 0 1-.177.33C21.388 24 18.26 24 12.001 24s-9.387 0-10.552-1.944a4 4 0 0 1-.178-.33c-.74-1.55.071-3.423 2.011-6.51C4.778 14.518 6.532 13.9 8 13.9"
            fill="currentColor"
        />
        <path
            d="M16.999.019a2.28 2.28 0 0 1 .346 4.454l-.346.098v5c.464.68.967 1.44 1.524 2.281.536.81 1.029 1.556 1.478 2.248-1.32.557-2.762 1-4.001 1-1.449 0-2.373-.598-3.501-1.349-1.125-.749-2.455-1.651-4.5-1.651-.993 0-2.036.213-3.03.522l.507-.77c.558-.841 1.062-1.601 1.526-2.28v-5l-.347-.1A2.28 2.28 0 0 1 7.002.02V0h9.997z"
            fill="currentColor"
        />
    </svg>
));
FlaskFilledSize24Glyph.displayName = 'FlaskFilledSize24Glyph';
